module.exports = __webpack_public_path__ + "static/img/swiper-4.76cafb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper-4.jpg
// module id = 6
// module chunks = 1